export const messageBusLinks = {
    root: "/message-bus",
};